import { track } from "jiffy-analytics";
import { getUserType, isUserLoggedIn } from "@design-lab/entities/user/lib/auth";
import { useTokenManagement } from "./tokenManagement";

type RequestMoreCreditsOptions = {
  deviceType?: "desktop" | "mobile";
};

export function useRequestMoreCredits(options: RequestMoreCreditsOptions = {}) {
  const { aiCreditsBalance, totalCredits } = useTokenManagement();

  const handleRequestMore = () => {
    const trackingData = {
      current_credits_balance: aiCreditsBalance,
      total_credits: totalCredits,
      credits_used: totalCredits - aiCreditsBalance,

      user_type: getUserType(),
      is_logged_in: isUserLoggedIn(),

      ...(options.deviceType && {
        device_type: options.deviceType
      }),

      timestamp: Date.now()
    };

    track("weave_more_credits_requested", trackingData);
  };

  return { handleRequestMore };
}
